// GTJ COUNSELLING CLASS FIX V3
// GTJ COUNSELLING TARGET FIX V2
// GTJ RESTORE COUNSELLING COLOR V1
// GTJ NAVBAR ACTIVE PAGE FIX V1
import "./NavBarActiveState.css";
import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import "./Navbarmodule.css";

const Navbar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const closeDrawer = () => setIsDrawerOpen(false);

  const goHome = () => {
    closeDrawer();
    navigate("/");
  };

  const goCounselling = () => {
    closeDrawer();
    navigate("/counselling");
  };

  return (
    <nav className="NavMain">
      <button
        type="button"
        className="companyname"
        onClick={goHome}
        aria-label="StudyAIPlacement Home"
      >
        <img
          src="/sneh-logo.png"
          alt="StudyAIPlacement"
          className="brand-logo-img"
        />
      </button>

      <button
        type="button"
        className="drawer-icon"
        onClick={() => setIsDrawerOpen((open) => !open)}
        aria-label="Toggle navigation"
      >
        {isDrawerOpen ? <FaTimes /> : <FaBars />}
      </button>

      <div className={`buttons ${isDrawerOpen ? "drawer-open" : ""}`}>
        <NavLink to="/" end className={({ isActive }) => `NavButton${isActive ? " gtj-nav-current" : ""}`} onClick={closeDrawer}>
          Home
        </NavLink>

        <NavLink
          to="/success-stories-newsletter"
          className={({ isActive }) => `NavButton${isActive ? " gtj-nav-current" : ""}`}
          onClick={closeDrawer}
        >
          Success Stories
        </NavLink>

        <NavLink
          to="/study-roadmap"
          className={({ isActive }) => `NavButton${isActive ? " gtj-nav-current" : ""}`}
          onClick={closeDrawer}
        >
          Study Roadmap
        </NavLink>

        <NavLink
          to="/fees-benefits"
          className={({ isActive }) => `NavButton fees-benefits-nav${isActive ? " gtj-nav-current" : ""}`}
          onClick={closeDrawer}
        >
          Fees & Career Blueprint
        </NavLink>

        <NavLink
          to="/admission"
          className={({ isActive }) => `NavButton admission-nav${isActive ? " gtj-nav-current" : ""}`}
          onClick={closeDrawer}
        >
          Apply for Admission
        </NavLink>

        <NavLink
          to="/global-talent"
          className={({ isActive }) => `NavButton global-talent-nav${isActive ? " gtj-nav-current" : ""}`}
          onClick={closeDrawer}
        >
          Apply for Jobs
        </NavLink>

        <NavLink
          to="/industry-experience"
          className={({ isActive }) => `NavButton industry-experience-nav${isActive ? " gtj-nav-current" : ""}`}
          onClick={closeDrawer}
        >
          Skilled, No Experience
        </NavLink>

        <button
          type="button"
          className="NavButton counselling-nav gtj-counselling-highlight"
          onClick={goCounselling}
        >
          Counselling
        </button>

        <NavLink
          to="/student-login"
          className={({ isActive }) => `NavButton student-login-nav${isActive ? " gtj-nav-current" : ""}`}
          onClick={closeDrawer}
        >
          Student Login
        </NavLink>
      </div>
    </nav>
  );
};

export default Navbar;
